<template>
  <div class="pad-bot20 backwhite width100">
    <el-skeleton class="width100" :loading="true" animated :throttle="500">
      <template slot="template">
        <div class="f16 width98 textalign-left pad-top20">
          <span class="dimensional">文档权限设置</span>
        </div>

        <!-- 检索 -->
        <div class="Retrieveform lineheight60 f14 bluecolor">
          <div>{{ titel }}</div>
        </div>
        <div class="flex-between">
          <div class="Enterprise width25 pername pad-bot10">
            <p class="personnel f14">企业人员</p>
            <el-checkbox-group
              v-model="checkList"
              v-for="(item, index) in page"
              :key="index"
              @change="PersonnelChange"
            >
              <el-checkbox class="pad-left10 pad-top10" :label="index">{{
                item.user.realname
              }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="main">
            <div>
              <div class="docTitle">
                <span>目录名称</span>
                <div class="docName">
                  <el-radio-group
                    v-model="radio"
                    v-for="(item, indexs) in name"
                    :key="indexs + 100"
                    class="docitems"
                  >
                    <el-radio
                      @click.native.prevent="radioClick(indexs, item, indexs)"
                      :label="indexs"
                      >{{ item }}</el-radio
                    >
                  </el-radio-group>
                </div>
              </div>
            </div>

            <!-- 这个循环是数组对象嘛 -->
            <div v-for="(item, indexs) in pages" :key="indexs">
              <div class="cont-items">
                <!-- 前面的名字 -->
                <span>{{ item.name }}</span>
                <div class="docName">
                  <!--  v-model="item.checkListcont", 把选择的结果填到数组对象里面,这样每一个对应的都不一样，也就不得重复了 -->
                  <el-radio-group
                    v-model="item.create_time"
                    class="docitems"
                    @change="itemChange(item, index)"
                    v-for="(it, index) in cont"
                    :key="index + 1000"
                  >
                    <el-radio :label="it"></el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="textalign-right margin-top20">
          <el-button class="f14" @click="nullpreservation()"> 取 消 </el-button>
          <el-button
            class="margin-top20 f14"
            type="primary"
            @click="topreservation()"
          >
            保存设置
          </el-button>
        </div>
      </template>
    </el-skeleton>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  bindstafflist,
  documentuserpermission,
  documentpermission,
} from "@/api/loader/loder.api";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      titel: "",
      result: [],
      checkList: [],
      page: "",
      pages: "",
      radio: "",
      radios: "",
      name: ["无", "可读", "可写"],
      cont: ["无", "可读", "可写"],
      PersonnelChangeid: [],
      permiss: [],
      title: "",
    };
  },
  methods: {
    radioClick(e, item, indexs) {
      e === this.radio ? (this.radio = 111) : (this.radio = e);
      if (this.radio == 0) {
        this.pages.forEach((i) => {
          i.create_time = "无";
          const b = {
            folder_id: i.id,
            permission: 0,
          };
          this.permiss.push(b);
        });
      } else if (this.radio == 1) {
        this.pages.forEach((i) => {
          i.create_time = "可读";
          const b = {
            folder_id: i.id,
            permission: 1,
          };
          this.permiss.push(b);
        });
      } else if (this.radio == 2) {
        this.pages.forEach((i) => {
          i.create_time = "可写";
          const b = {
            folder_id: i.id,
            permission: 2,
          };
          this.permiss.push(b);
        });
      } else {
        this.pages.forEach((i) => {
          i.create_time = "";
          this.permiss = [];
        });
      }
    },
    PersonnelChange(val) {
      val.forEach((i) => {
        this.PersonnelChangeid.push(this.page[i].user_id);
      });
    },
    itemChange(item, index) {
      this.radio = 3;
      let m = 0;
      let n = 0;
      let l = 0;
      this.pages.forEach((i) => {
        if (i.create_time == "无") {
          m++;
        } else if (i.create_time == "可读") {
          n++;
        } else if (i.create_time == "可写") {
          l++;
        }
      });
      if (m == 10) {
        this.radio = 0;
      } else if (n == 10) {
        this.radio = 1;
      } else if (l == 10) {
        this.radio = 2;
      }
      const a = {
        folder_id: item.id,
        permission: index,
      };
      this.permiss.push(a);
    },
    topreservation() {
      this.permiss.reverse();
      const removeDuplicateObj = (arr) => {
        let obj = {};
        this.permiss = this.permiss.reduce((newArr, next) => {
          obj[next.folder_id]
            ? ""
            : (obj[next.folder_id] = true && newArr.push(next));
          return newArr;
        }, []);
        return this.permiss;
      };

      const result = Array.from(new Set(this.PersonnelChangeid));
      documentpermission({
        users: result,
        permission: this.permiss,
        ent_id: window.sessionStorage.getItem("businessentid"),
      }).then((res) => {
        if (res.data.code == 200) {
          BUS.$emit("addpeople", "yes");
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    nullpreservation() {
      BUS.$emit("addpeople", "yess");
    },
  },
  created() {
    this.titel = window.sessionStorage.getItem("companytitle");
    //   人员清单
    bindstafflist({
      all: 1,
      ent_id: window.sessionStorage.getItem("businessentid"),
    }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    documentuserpermission({
      ent_id: window.sessionStorage.getItem("businessentid"),
    }).then((res) => {
      if (res.data.code == 200) {
        this.pages = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.Retrieveform {
  background: #fff;
}
.main {
  width: 73%;
  border: 1px solid #bbbbbb;
  margin-left: 10px;
}
.Personnel-list {
  display: flex;
  flex-wrap: nowrap;
  padding-top: 20px;
}
.personnel {
  border-bottom: 1px solid #efefef;
  text-align: center;
  padding: 10px 0 10px 0;
}
.pername {
  border: 1px solid #bbbbbb;
}
.docTitle {
  padding: 0 10px 10px 10px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  border-bottom: 1px solid #efefef;
  margin: 10px 0 0 0;
}
.cont-items {
  padding: 20px 10px 5px 10px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.docName {
  width: 50%;
  display: flex;
}
.docitems {
  width: 33.3%;
  text-align: right;
}
.Permission-configuration {
  background: #409eff;
  color: white;
  width: 80px;
  text-align: center;
  border-radius: 5px;
  line-height: 30px;
  float: right;
  margin-top: 20px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>